import { render, staticRenderFns } from "./OmaProcedure.vue?vue&type=template&id=c92304ac"
import script from "./OmaProcedure.vue?vue&type=script&lang=js"
export * from "./OmaProcedure.vue?vue&type=script&lang=js"
import style0 from "./OmaProcedure.vue?vue&type=style&index=0&id=c92304ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports